import React, { useContext, useEffect, useState } from 'react';
import { View, colors, Page, Grid, GridColumn } from '@fairygodboss/ui';
import {
    CommunityContext,
    PageContext,
} from '../../../../../contexts/ContextCreator';
import {
    CommentsHeader,
    CommentConvincer,
    CommentSection,
    UserProfile,
} from './components';

export const Comments = ({ context }) => {
    const {
        type,
        hash,
        comments: initialComments,
        lastId,
        editorRef,
        isCommunityDiscussionType,
    } = context();
    const [comments, setComments] = useState(initialComments);
    const { fetchMoreComments, getContent } = useContext(CommunityContext);
    const { isLoggedIn } = useContext(PageContext);
    const [numberOfCommentsToShow, setNumberOfCommentsToShow] = useState(2);
    const content = getContent(hash);
    useEffect(() => {
        setComments(content.comments);
    }, [hash, getContent, content]);

    useEffect(() => {
        fetchMoreComments(type, hash);
    }, [type, hash, fetchMoreComments]);

    const [mounted, setMounted] = useState(false);
    useEffect(() => {
        setMounted(true);
    }, []);

    return (
        <View
            id="comment-body"
            display="flex"
            width="100%"
            minHeight="477px"
            css={{
                fontFamily: 'Open Sans',
                color: colors.neutral[100],
            }}
            backgroundColor="#F9F9FB"
            position="relative"
        >
            <View id="anchor-comment-body" position="absolute" top="-56px" />

            <View
                display="flex"
                width="100%"
                flexDirection="column"
                alignItems="center"
            >
                <Page width="100%">
                    <Grid
                        id="grid-test"
                        maxWidth="1176px"
                        pl={{ _: '16px', md: '24px', lg: '8px' }}
                        pr={{ _: '16px', md: '0px', lg: '16px' }}
                        justifyContent={{
                            _: 'left',
                            sm: 'center',
                            md: 'left',
                            lg: 'right',
                        }}
                    >
                        <GridColumn
                            size={{ xs: 12, sm: 9, md: 12, lg: 11 }}
                            pl="100px"
                            backgroundColor="red"
                            css={{
                                paddingLeft: '0px',
                                paddingRight: '0px',
                                position: 'relative',
                            }}
                        >
                            {!isLoggedIn() ? (
                                <CommentConvincer type={type} />
                            ) : (
                                <UserProfile />
                            )}
                            {mounted ? (
                                <>
                                    <CommentsHeader
                                        editorRef={editorRef}
                                        commentCount={content.commentCount}
                                        onPost={() => {
                                            setNumberOfCommentsToShow(
                                                numberOfCommentsToShow + 1
                                            );
                                        }}
                                        type={type}
                                        hash={hash}
                                        isLoggedIn={isLoggedIn()}
                                        isCommunityDiscussionType={
                                            isCommunityDiscussionType
                                        }
                                    />
                                    <CommentSection
                                        isLoggedIn={isLoggedIn()}
                                        lastId={lastId}
                                        comments={comments}
                                        type={type}
                                        hash={hash}
                                        numberOfCommentsToShow={
                                            numberOfCommentsToShow
                                        }
                                        contentUrl={content.contentUrl}
                                        isCommunityDiscussionType={
                                            isCommunityDiscussionType
                                        }
                                    />
                                </>
                            ) : null}
                        </GridColumn>
                    </Grid>
                </Page>
            </View>
        </View>
    );
};

Comments.display = 'Comments';
